import styled from "styled-components";
export const PDFViewerContainer = styled.div `
  position: relative;

  /* Style for the tab container */
  .tab-container {
    display: flex;
    background-color: #f2f2f2;
    overflow: hidden;
  }

  /* Style for the individual tabs */
  .tab {
    flex: 1;
    padding: 10px 20px;
    text-align: center;
    cursor: pointer;
    background-color: #ccc;
    border: 1px solid #888;
    user-select: none;
  }

  /* Change the background color when a tab is clicked or hovered over */
  .tab:hover {
    background-color: #ddd;
  }

  /* Style the content of the tabs */
  .tab-content {
    display: none;
    padding: 20px;
    border: 1px solid #888;
    border-top: none;
  }

  /* Display the content of the active tab */
  .tab-content.active {
    display: block;
  }

  .react-pdf__Document {
    border-radius: var(--rounded-corners-large);
    max-width: 100%;
    position: relative;
    background-color: #fff;
    overflow: hidden;
    text-align: center;
    border: solid;
  }

  .textLayer {
    position: absolute;
    text-align: initial;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    line-height: 1;
    text-size-adjust: none;
    forced-color-adjust: none;
    transform-origin: 0 0;
    z-index: 2;
  }

  .annotationLayer {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    transform-origin: 0 0;
  }

  .footer-file-view {
    position: absolute;
    bottom: 20px;
  }

  .page-controls-viewer {
    position: absolute;
    bottom: 5%;
    left: 50%;
    background: white;
    transform: translate(-50%);
    transition: opacity ease-in-out 0.2s;
    box-shadow: var(--shadow);
    border-radius: var(--rounded-corners);
    z-index: 9999999;
    background-color: green;
  }

  .file-list-wrapper {
    display: flex;
    border: sod;
  }

  .form-comment-container {
  }

  .comment-edit-span {
    button {
      color: ${(props) => props.theme.colorPalette.secondaryColor};
      :hover {
        color: ${(props) => props.theme.colorPalette.primaryColor};
      }
    }
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: green;
    text-shadow: 0 0 0.25px currentcolor;
  }
`;
